module.exports = __webpack_public_path__ + "img/5.06ae7ab3.png";